__turbopack_context__.v({
  "divider": "experiments-module-scss-module__E7UYWa__divider",
  "list": "experiments-module-scss-module__E7UYWa__list",
  "section": "experiments-module-scss-module__E7UYWa__section",
});
